import imageToBase64 from 'image-to-base64/browser';

export const formatUrl = async (imageUrl) => {
  const isLocalhost = window.location.hostname === 'localhost'

  if (isLocalhost) {
    return imageUrl;
  }

  if (imageUrl && !imageUrl.includes("no-image")) {
    const base64 = await imageToBase64(imageUrl);
    return 'data:image/png;base64,' + base64;
  }
  else {
    return imageUrl;
  }
}